import { FETCH_AUTOMATION_CUSTOMERS } from '../../actions/cm/automation';
import {
  SAVE_AUTOMATION_CUSTOMERS,
  SAVE_AUTOMATION_CUSTOMERS_FAIL,
  SAVE_AUTOMATION_CUSTOMERS_SUCCESS,
  RESET_AUTOMATION_CUSTOMERS_ERROR
} from '../../actions/cm/automationCustomers';

export const initialState = {
  isLoading: false,
  hasError: false,
  errorMessage: '',
  showSaveSuccess: false
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case SAVE_AUTOMATION_CUSTOMERS:
      return {
        ...state,
        isLoading: true,
        hasError: false
      };
    case SAVE_AUTOMATION_CUSTOMERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        showSaveSuccess: true
      };
    case SAVE_AUTOMATION_CUSTOMERS_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        errorMessage: payload.message
      };
    case FETCH_AUTOMATION_CUSTOMERS:
      return {
        ...state,
        showSaveSuccess: false
      };
    case RESET_AUTOMATION_CUSTOMERS_ERROR:
      return {
        ...state,
        hasError: false
      };

    default:
      return state;
  }
}
